

// questionLogicEvaluator.js

export const evaluateQuestionLogic = (
  questionLogic,
  courseDesignState,
  studentAnswersState
) => {
  // Per‑call memoization cache keyed by logic string
  const cache = {};

  // Your existing thesis‑abbreviation replacer, unchanged
  const replaceThesisAbbreviations = (logic) => {
    const thesisRegex = /\(([^,\s()]+)\)/g;
    let updated = logic;

    updated = updated.replace(thesisRegex, (match, thesisName) => {
      const thesisItem = courseDesignState.find(
        item => item.dataType === 'thesis' && item.dataText === thesisName
      );
      if (thesisItem && thesisItem.questionLogic) {
        return `(${thesisItem.questionLogic})`;
      }
      return match;
    });

    if (updated !== logic) {
      return replaceThesisAbbreviations(updated);
    }
    return updated;
  };

  // Normalize symbols & thesis refs
  const normalize = (logic) =>
    replaceThesisAbbreviations(logic)
      .replace(/&/g, '&&')
      .replace(/¬/g, '!')
      .replace(/∨/g, '||');

  const answerRegex = /\(([^,()]+),\s*(\d+)\)/g;

  // Recursive evaluator
  const evalLogic = (logic) => {
    const key = logic.trim();
    if (cache[key] !== undefined) {
      return cache[key];
    }
    // Base case: empty logic means “always show”
    if (!key) {
      cache[key] = true;
      return true;
    }

    // 1) Normalize the string
    let processed = normalize(logic);

    // 2) Guard & replace all (questionID,answerNum) tests
    processed = processed.replace(answerRegex, (match, qID, ansNum) => {
      // (a) If the referenced question is hidden, short‑circuit to false
      const questionItem = courseDesignState.find(item => item.dataID === qID);
      if (!questionItem) {
        return 'false';
      }
      const isVisible = evalLogic(questionItem.questionLogic);
      if (!isVisible) {
        return 'false';
      }
      // (b) Otherwise, perform your usual answer‑check
      const studentAns = studentAnswersState.find(a => a.questionID === qID);
      if (studentAns) {
        const val = studentAns.questionAnswer || studentAns.questionEssayAnswer;
        return (val && val.includes(ansNum)) ? 'true' : 'false';
      }
      return 'false';
    });

    // 3) Finally, eval the boolean expression
    let result = false;
    try {
      // eslint-disable-next-line no-eval
      result = !!eval(processed);
    } catch (err) {
      console.error('Logic eval error:', processed, err);
      result = false;
    }

    cache[key] = result;
    return result;
  };

  // Kick off the recursion
  return evalLogic(questionLogic);
};
